import {Injectable} from '@angular/core';
import {BaseModelService} from '../../base-model.service';

@Injectable({
  providedIn: 'root'
})
export class HolidaysTypesModelService extends BaseModelService {

  tableName = 'yu_v3_holidays_types';

}
